import React from "react";
import { NavLink } from "react-router-dom";
import Facebook from '../assets/facebook.svg';
import Twitter from '../assets/twitter.svg';
import Ig from '../assets/ig.svg';
const Footer = () => {
  return (
    <div className="header-footer">
      <div className="footer">
        <div className="footer-wrapper container">
          <div className="footer-content">
            <section>
              <ul>
                <li className="footer-text" onClick={() => window.scrollTo(0, 0)}>
                  <NavLink to="/">Karir</NavLink>
                </li>
                <li className="footer-text">Blog</li>
                <li className="footer-text">Official Store</li>
                <li className="footer-text">Tagihan & Top up</li>
                <li className="footer-text">Syarat dan ketentuan</li>
              </ul>
            </section>
            <section className="promotions">
              <ul>
                <li className="footer-text">Tiket Kereta</li>
                <li className="footer-text">Pusat Penjualan</li>
                <li className="footer-text">Hotlist</li>
                <li className="footer-text">Keuangan</li>
                <li className="footer-text">Kebijakan Privasi</li>
              </ul>
            </section>
            <section className="become-partner">
              <ul>
                <li className="footer-text">Bantuan Tokopedia</li>
                <li className="footer-text">Aplikasi Tokopedia</li>
                <li className="footer-text">Mitra Toppers</li>
                <li className="footer-text">Daftar Official Store</li>
              </ul>
            </section>

            <section className="become-partner">
              <ul>
                <li className="footer-text">Kategori</li>
                <li className="footer-text">Kamus Tokopedia</li>
                <li className="footer-text">Deals Tokopedia</li>
                <li className="footer-text">Tiket Pesawat</li>
              </ul>
            </section>
          </div>
          <div className="follow">
            <p className="footer-text">Ikuti kami di : </p>
            <img src={Facebook} alt='facebook logo' className="sosmed" />
            <img src={Twitter} alt='twitter logo' className="sosmed" />
            <img src={Ig} alt='instagram logo' className="sosmed" />
          </div>
        </div>
      </div>
      <div className="under-footer container">
        <p>©</p>
        <div className="block">
          <p>2020-2021, MoshiMoshiMall</p>
          <p>Server process time: 0.096 secs.</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
